<template>
  <div>
    <div>
      <label for="file-upload"
             class="custom-file-upload">
        <i class="fa fa-cloud-upload"></i> Upload
      </label>
      <input type="file"
             name=""
             id="file-upload"
             multiple
             @change="filesChange($event.target.files)">
    </div>
    <el-tag v-for="(file,index) in files"
            :key="index"
            closable
            @close="fileRemove(file)">
      {{file.name}}
    </el-tag>
  </div>
</template>

<script>
export default {
  created() {
    this.bus.$on('clearData', () => {
      this.files = [];
      this.formData = new FormData();
    });
  },
  data() {
    return {
      files: [],
      formData: new FormData(),
    };
  },
  props: ['bus'], // The bus is from mail/Index
  watch: {
    files() {
      this.$emit('updateFiles', this.formData);
    },
  },
  methods: {
    filesChange(fileList) {
      if (!fileList.length) return;
      Array.from(Array(fileList.length).keys()).map(x => {
        this.formData.append(fileList[x].name, fileList[x]);
        this.files.push({ name: fileList[x].name });
      });
    },
    fileRemove(file) {
      this.formData.delete(file.name);
      this.files = this.files.filter(f => f.name !== file.name);
    },
  },
};
</script>

<style lang="scss" scoped>
input[type='file'] {
  position: fixed;
  right: 100%;
  bottom: 100%;
}
.custom-file-upload {
  background-color: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  display: inline-block;
  padding: 0px 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/mail/Attachement.vue